import { ConnectionNames } from "../types";
export const ConfigStore = {
    config: {
        connections: {
            inactiveTTL_MS: 5000
        },
        urls: {},
        msgBus: {}
    }
};
//# sourceMappingURL=index.js.map